__turbopack_context__.v({
  "appear": "form-module-scss-module__LnxMCq__appear",
  "checkboxes": "form-module-scss-module__LnxMCq__checkboxes",
  "formHeader": "form-module-scss-module__LnxMCq__formHeader",
  "root": "form-module-scss-module__LnxMCq__root",
  "select": "form-module-scss-module__LnxMCq__select",
  "select__helperText": "form-module-scss-module__LnxMCq__select__helperText",
  "textarea": "form-module-scss-module__LnxMCq__textarea",
  "title": "form-module-scss-module__LnxMCq__title",
});
